import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private loadingMap: Record<string, boolean> = {};

  startLoading(key: string) {
    this.loadingMap[key] = true;
  }

  stopLoading(key: string) {
    this.loadingMap[key] = false;
  }

  isLoading(key: string): boolean {
    return !!this.loadingMap[key];
  }
}
